import React, { useEffect, useState } from "react";
import salonService from "../../services/SalonService";
import "./MyMemberships.css";
import { useSalon } from "../../context/SalonContext";
import GlobalLoader from "../loadingIndicator/GlobalLoader";

export default function MyMemberships() {
    const { salonUuid, customerId, setMembershipCount } = useSalon();
    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPlans = async () => {
            try {
                let mySalonUuid = salonUuid ? salonUuid : localStorage.getItem("SALON_UUID");
                const response = await salonService.getCustomerMemberships(mySalonUuid, customerId);
                if (response.status === 200) {
                    setPlans(response.data);
                    setMembershipCount(response.data.length); // ✅ update count in context
                }
            } catch (error) {
                console.error("Failed to fetch memberships", error);
            } finally {
                setLoading(false);
            }
        };

        fetchPlans();
    }, []);

    if (loading) return <GlobalLoader />;

    return (
        <div className="my-memberships-container">
            <h2 className="header-title">My Memberships</h2>
            {plans.length === 0 ? (
                <p>You have not purchased any memberships yet.</p>
            ) : (
                <div className="plans-list">
                    {plans.map((plan) => (
                        <div
                            className={`plan-card ${plan.active ? "active" : "inactive"}`}
                            key={plan.id}
                        >
                            <h3>{plan.name}</h3>
                            <p className="salon-name">Salon: {plan.salonName}</p>
                            <p>Price: ₹{plan.price}</p>
                            <p>
                                Valid Till:{" "}
                                {new Date(plan.validTill).toLocaleDateString("en-IN", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                })}
                            </p>

                            {/* ✅ Show verified status */}
                            {!plan.verifiedByOwner ? (
                                <p className="verification-status pending">
                                    ⏳ Pending approval by salon owner
                                </p>
                            ) : (
                                <p className="verification-status verified">✔ Verified</p>
                            )}

                            {/* ✅ Show active/expired */}
                            {/* <p className={`plan-status ${plan.active ? "active" : "inactive"}`}>
                                {plan.active ? "Active ✅" : "Expired ❌"}
                            </p> */}
                            <p className={`plan-status ${plan.status === 'ACTIVE' ? "active" : "inactive"}`}>
                                {plan.status}
                            </p>

                            {/* ✅ Show remaining days if active */}
                            {plan.active && plan.remainingDays !== undefined && (
                                <p className="remaining-days">
                                    🗓 {plan.remainingDays} days remaining
                                </p>
                            )}

                            <div className="plan-benefits">
                                <h4>Benefits:</h4>
                                <ul>
                                    {plan.benefits.map((benefit, idx) => {
                                        let highlighted = benefit
                                            .replace(/(free)/gi, '<span class="highlight-free">$1</span>')
                                            .replace(/(discount)/gi, '<span class="highlight-discount">$1</span>');

                                        let icon = "✅";
                                        if (/free/i.test(benefit)) icon = "🎁";
                                        else if (/discount/i.test(benefit)) icon = "💸";

                                        return (
                                            <li key={idx}>
                                                <span className="benefit-icon">{icon}</span>
                                                <span dangerouslySetInnerHTML={{ __html: highlighted }} />
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>

                    ))}
                </div>
            )}
        </div>
    );
}
